"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _system = require("@mui/system");
var _theme = require("../theme");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * 
 * @returns 
 */
var ModalContent = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var customStyle = props.customStyle;
  var StyledDiv = (0, _system.styled)('div')(function (_ref) {
    var theme = _ref.theme;
    return _objectSpread((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])({
      '@media (maxWidth: 2300px)': {
        width: '75%'
      },
      '@media (maxWidth: 2000px)': {
        width: '90%'
      },
      '@media (maxWidth: 600px)': {
        width: '95%'
      },
      '@media (maxWidth: 400px)': {
        width: '98%'
      },
      maxWidth: 1350,
      top: '50%',
      left: '50%',
      minWidth: '648px',
      outline: 'none',
      position: 'absolute',
      boxShadow: '0 1px 2px rgba(0, 0, 0, .15)',
      transform: 'translate(-50%, -50%)',
      WebkitTransform: 'translate(-50%, -50%)'
    }, theme.breakpoints.down('666'), {
      maxWidth: '75%',
      minWidth: 'unset'
    }), "display", 'flex'), "flexDirection", 'column'), "flexWrap", 'wrap'), "borderRadius", '12px'), "padding", '20px'), "backgroundColor", _theme.colors.surface), customStyle);
  });
  var children = props.children;
  return /*#__PURE__*/_react["default"].createElement(StyledDiv, props, children);
});
var _default = exports["default"] = ModalContent;